import submit from "submit-form";
import getErrorMessage from "./getErrorMessage";
import i18n from "../i18n";

export const validateCreateQuestion = (question, assert, flash) => {
  try {
    const { title, type, body } = question;

    assert(title, 400, i18n.t("common:validation.titleRequired"));

    if (type === "multiple" || type === "checkbox") {
      assert(body.options, 400, i18n.t("common:validation.optionsRequired"));
      assert(
        body.options.length > 0,
        400,
        i18n.t("common:validation.optionsRequired")
      );

      const isSameLength = new Set(body.options).size === body.options.length;
      assert(
        isSameLength,
        400,
        i18n.t("common:validation.optionsMustBeUnique")
      );
    }

    if (type === "scale") {
      assert(
        body.labelLeft,
        400,
        i18n.t("common:validation.leftLabelRequired")
      );
      assert(
        body.labelRight,
        400,
        i18n.t("common:validation.rightLabelRequired")
      );
      assert(
        body?.labelLeft?.length <= 40,
        400,
        i18n.t("common:validation.leftLabelTooLong")
      );
      assert(
        body?.labelRight?.length <= 40,
        400,
        i18n.t("common:validation.rightLabelTooLong")
      );
    }

    if (type === "measurement") {
      assert(
        body.options,
        400,
        i18n.t("common:validation.measurementOptionsRequired")
      );
      assert(
        body.options.length > 0,
        400,
        i18n.t("common:validation.measurementOptionsRequired")
      );
    }

    return true;
  } catch (error) {
    flash("error", getErrorMessage(error));
    submit("/actions/refresh");
    return false;
  }
};

export const validateCreateTemplate = (template, assert, flash) => {
  try {
    const { title, questions } = template;

    assert(title, 400, i18n.t("common:validation.titleRequired"));

    assert(
      questions.length,
      400,
      i18n.t("common:validation.questionsRequired")
    );

    assertQuestionField(questions, "bodyweight", assert);
    assertQuestionField(questions, "progress", assert);
    assertQuestionField(questions, "nutrition", assert);
    assertQuestionField(questions, "steps", assert);
    assertQuestionField(questions, "sleep", assert);
    assertQuestionField(questions, "hrv", assert);
    assertQuestionField(questions, "measurement", assert);

    return true;
  } catch (error) {
    flash("error", getErrorMessage(error));
    submit("/actions/refresh");
    return false;
  }
};

const assertQuestionField = (questions, field, assert) => {
  const totalFieldQuestions = questions.filter(
    (question) => question.type === field
  );

  assert(
    totalFieldQuestions.length <= 1,
    400,
    i18n.t("common:validation.onlyOneFieldAllowed", { field })
  );
};

export const validateCreateIndividualQuestion = (questions, assert, flash) => {
  try {
    assert(
      questions.length,
      400,
      i18n.t("common:validation.questionsRequired")
    );

    assertQuestionField(questions, "bodyweight", assert);
    assertQuestionField(questions, "progress", assert);
    assertQuestionField(questions, "nutrition", assert);
    assertQuestionField(questions, "steps", assert);
    assertQuestionField(questions, "sleep", assert);
    assertQuestionField(questions, "hrv", assert);
    assertQuestionField(questions, "measurement", assert);

    return true;
  } catch (error) {
    flash("error", getErrorMessage(error));
    submit("/actions/refresh");
    return false;
  }
};

export const validateSchedule = (schedule, assert, flash) => {
  try {
    const { startDay, frequency, selectedWeeklyDays } = schedule;

    assert(
      frequency,
      400,
      i18n.t("common:validation.selectFrequency")
    );
    assert(startDay, 400, i18n.t("common:validation.selectDay"));

    if (frequency === "daily") {
      let hasTrueValue = false;
      for (const day in selectedWeeklyDays) {
        if (selectedWeeklyDays[day].active === true) {
          hasTrueValue = true;
        }
      }

      assert(
        hasTrueValue,
        400,
        i18n.t("common:validation.selectAtLeastOneDay")
      );
    }

    return true;
  } catch (error) {
    flash("error", getErrorMessage(error));
    submit("/actions/refresh");
    return false;
  }
};

export const isQuestionReady = (question) => {
  const { title, type, body } = question;

  let ready = false;

  if (title) ready = true;

  if (type === "multiple" || type === "checkbox") {
    const lengthReady = body.options && body.options.length > 0 ? true : false;
    const duplicateReady = new Set(body.options).size === body.options.length;

    ready = lengthReady && duplicateReady;
  }

  if (type === "scale") {
    ready = body.labelLeft && body.labelRight ? true : false;
  }

  if (type === "measurement") {
    ready = body.options && body.options.length > 0;
  }

  return ready;
};

export const isUnchanged = (question) => {
  const { title, type, body } = question;

  const titleUnchanged = title === "";
  const typeUnchanged = type === "short";
  const defaultShort = i18n.t(
    "athlete-portal:questionTypeDefaults.shortDescription"
  );
  const bodyUnchanged =
    body?.description === defaultShort ||
    body?.description === "Short Answer";

  return titleUnchanged && typeUnchanged && bodyUnchanged;
};
